import React from "react";
import BasePage from "basecomponents/BasePage";

import { Route, Routes as Switch } from "react-router-dom";

import ClientSidebar from "layout/ClientSidebar";
import ClientTopBarMobile from "layout/ClientTopBarMobile";
import ClientTopBar from "layout/ClientTopBar";

// Articulos / Ingreso de compra
import ClientDashboardArticles from "innerpages/ClientDashboardArticles";
import ClientDashboardArticle from "innerpages/ClientDashboardArticle";

// Paquetes
import ClientDashboardPackages from "innerpages/ClientDashboardPackages";
import ClientDashboardPackagesArchived from "innerpages/ClientDashboardPackagesArchived";
import ClientDashboardPackage from "innerpages/ClientDashboardPackage";

// Cuenta
import ClientDashboardAccount from "innerpages/ClientDashboardAccount";
import ClientDashboardNotifications from "innerpages/ClientDashboardNotifications";

import { initSidebarMenu } from "../utils/domUtils";
class ClientDashboard extends BasePage {
  componentDidMount(): void {
    setTimeout(() => {
      initSidebarMenu();
    }, 2000);
  }
  componentDidUpdate() {
    initSidebarMenu();
  }

  render() {
    return this.renderPage(
      <div id="containerbar">
        <ClientSidebar />
        <div className="rightbar">
          <ClientTopBarMobile />
          <ClientTopBar />

          <div className="contentbar">
            <div
              style={{
                marginTop: "4rem",
              }}
            >
              <Switch>
                {/* Articulos */}
                <Route path="articulos" element={<ClientDashboardArticles />} />
                <Route
                  path="articulos/nuevo"
                  element={<ClientDashboardArticle />}
                />
                <Route
                  path="articulos/editar"
                  element={<ClientDashboardArticle />}
                />

                {/* Paquetes */}
                <Route path="paquetes" element={<ClientDashboardPackages />} />
                <Route
                  path="paquetes/archivados"
                  element={<ClientDashboardPackagesArchived />}
                />
                <Route
                  path="paquetes/nuevo"
                  element={<ClientDashboardPackage />}
                />
                <Route
                  path="paquetes/editar"
                  element={<ClientDashboardPackage />}
                />

                <Route path="account" element={<ClientDashboardAccount />} />
                <Route
                  path="account/notificaciones"
                  element={<ClientDashboardNotifications />}
                />
              </Switch>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ClientDashboard;
